import { QuestionType } from '@empathy/survey/base';

export const QuestionTypeLabels: Record<QuestionType, string> = {
  [QuestionType.SingleChoice]: 'Single Choice',
  [QuestionType.MultiChoice]: 'Multi Choice',
  [QuestionType.Dropdown]: 'Dropdown',
  [QuestionType.Input]: 'Textbox',
  [QuestionType.Essay]: 'Open Ended Question',
  [QuestionType.Carousel]: 'Carousel',
  [QuestionType.CarouselMultiChoice]: 'Carousel Multi Choice',
  [QuestionType.CarouselRating]: 'Carousel Rating',
  [QuestionType.Rating]: 'Rating',
  [QuestionType.Heatmap]: 'Image Heatmap',
  [QuestionType.InfoPage]: 'Info Page',
  [QuestionType.FileUpload]: 'File Upload',
  [QuestionType.Terminate]: 'Terminate',
  [QuestionType.AIChat]: 'AI Chat',
  [QuestionType.NPS]: 'NPS',
  [QuestionType.Ranking]: 'Ranking Question',
  [QuestionType.RankSort]: 'Rank Sort',
  [QuestionType.HiddenChoice]: 'Hidden Choice'
};
